// extracted by mini-css-extract-plugin
export var avatarContainer = "_br-0";
export var gray = "_br-f";
export var green = "_br-c";
export var icon = "_br-9";
export var image = "_br-1";
export var lg = "_br-6";
export var md = "_br-5";
export var presenceDot = "_br-b";
export var red = "_br-d";
export var sm = "_br-4";
export var status = "_br-a";
export var xl = "_br-7";
export var xs = "_br-3";
export var xxl = "_br-8";
export var xxs = "_br-2";
export var yellow = "_br-e";